export enum GreetingType {
  Friendly = "friendly",
  Formal = "formal",
  Spanish = "spanish",
  Japanese = "japanese",
}
